import React, { useEffect, useState } from "react";
import Nav from "../components/nav";
import Footer from "../components/footer";
import {
  ArrowRight,
  ArrowRightAltOutlined,
  ContentPaste,
  Lock,
  QrCode,
  QrCode2,
} from "@mui/icons-material";
import USDT from "../assets/us.jpg";
import { Spinner, Toast, useToast } from "@chakra-ui/react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import swal from "sweetalert";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import useAuth from "../hooks/auth";
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";
import { db } from "../config";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { useDisclosure } from "@chakra-ui/react";
import QRmodal from "../components/qrmodal";

function Deposit(props) {
  const [amount, setAmount] = useState();
  const [value, setValue] = useState(
    "0x55f50fFd952F0622821bB789668011196076AfF4"
  );
  const [coin] = useState(JSON.parse(localStorage.getItem("plan")));
  const [feedback, setFeedback] = useState("");
  const { user, isLoading: authLoading } = useAuth();
  const nav = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const toast = useToast();

  const proceed = (e) => {
    e.preventDefault();
    const planDetails = JSON.parse(localStorage.getItem("plan"));
    if (!amount || amount < planDetails.minDepo) {
      toast({
        title: planDetails.name + " Error",
        description:
          "Amount must be atleast $" + planDetails.minDepo + " and above!",
        position: "top",
        status: "error",
        variant: "subtle",
        duration: "8000",
        isClosable: true,
      });

      return;
    } else {
      localStorage.setItem("amount", amount);
      toast({
        description: "Once payment is confirmed your balance will be updated!",
        status: "info",
        duration: "3000",
        isClosable: true,
        position: "top",
        colorScheme: "blue",
        variant: "subtle",
      });
      nav("/usdtpay");
    }
  };
  if (!user) return <Loading />;

  return (
    <div>
      <div className="app">
        <div className="main-body">
          <div className="plan_bg">
            <Nav />
            <br />

            <h4 className="faint text-center">Deposit Funds</h4>

            <form autoComplete="false" className="mx-4 mt-5">
              <input
                type="number"
                className=" mt-3 form-control  "
                placeholder="Enter amount($)"
                autoComplete="off"
                value={amount}
                onChange={(e) => {
                  setAmount(e.target.value);
                }}
              />
              <select className="form-select mt-2">
                <option selected>USDT</option>
                <option selected>XRP</option>
                <option selected>BITCOIN(BTC)</option>
                <option selected>SOLANA(SOL)</option>
                <option selected>ETHEREUM(ETH)</option>
              </select>

              <input
                type="hidden"
                placeholder="Message"
                className="form-control text-white"
                name="message"
                value={
                  user?.name + " claims he sent a worth of " + amount + " $"
                }
              />

              <button className="btn text-white MYbutton" onClick={proceed}>
                Proceed to make payment <ArrowRightAltOutlined />
              </button>
            </form>
            <br />
          </div>
          <br />
          <br />
          <br />
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Deposit;

// PAGE TO DISPLAY WALLET ADDRESS

export function USDTpage(props) {
  const [amount, setAmount] = useState(
    JSON.parse(localStorage.getItem("amount"))
  );
  const [value, setValue] = useState(
    "0x0a2dC94eb640F3e43c4B55a46f0DEBF247d0B5c9"
  );

  const [ETH, setEth] = useState("0x0a2dC94eb640F3e43c4B55a46f0DEBF247d0B5c9");
  const [SOL, setSOL] = useState(
    "BNi8uWd2rYogTfJCDxS7XCNP9rHRMtjw6qbXayNQBuUr"
  );
  const [BTC, setBTC] = useState("bc1qazwxsdpa0muyuvufezyy7djd5lclz4kf56wx7a");
  const [XRP, setXrp] = useState("rnBXnR7cmHmxopV68TSvftytAEHJp6JtSn");
  const [coin] = useState(JSON.parse(localStorage.getItem("plan")));
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { user, isLoading: authLoading } = useAuth();

  const Toast = useToast();
  const copied = () => {
    Toast({
      title: "Address copied",
      isClosable: true,
      duration: 2000,
      variant: "subtle",
      position: "top",
    });
  };
  // const navigate = useNavigate();
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    setLoading(true);
    emailjs
      .sendForm(
        "service_88djxc8",
        // "service_ua10ii6",

        "template_vqo4d0n",
        // "template_7cswhf4",
        form.current,

        "_kkncuU-hmyxwQgLs"
      )
      .then(
        (result) => {
          console.log(result.text);

          Toast({
            description:
              "Once payment is confirmed your balance will be updated!",
            status: "success",
            duration: "3000",
            isClosable: true,
            position: "top",
            colorScheme: "blue",
            variant: "subtle",
          });
          setDoc(doc(db, "Depositors", user?.id), {
            email: user?.email,
            referer: user?.userReferer,
            earnings: user?.earnings,
            coin: JSON.parse(localStorage.getItem("coin"))?.name || '',
            deposit: amount,
            created_at: serverTimestamp(),
          });

          
          localStorage.removeItem("plan");

          swal(
            "Almost there!",
            "Once payment is confirmed your balance will be updated!",
            "info"
          );
          setLoading(false);
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
          swal("", "An error occured", "info");
        }
      );
    // navigate("/dashboard");
  };

  return (
    <div className="app">
      <div className="main-body" style={{ height: "100vh" }}>
        <Nav />
        <QRmodal isOpen={isOpen} onClose={onClose} onOpen={onOpen} />

        <div
          className="plan_bg"
          style={{
            height: "288vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <center>
            <div className="address-section ">
              <h5>
                USDT ADDRESS (<b>ERC20</b>){" "}
              </h5>
              <p style={{ color: "white", fontSize: "13px", padding: "10px" }}>
                Send only Tether (ERC20) to this address. Sending any other
                coins may results in permanent loss.
              </p>
              <img src={USDT} alt="" />
              <div
                className="d-flex justify-content-center align-center "
                style={{ flexDirection: "column", alignItems: "center" }}
              >
                <div className="address-div" style={{ fontSize: "14px" }}>
                  {" "}
                  {value}
                </div>
                <CopyToClipboard text={value}>
                  <button className="btn" onClick={copied}>
                    copy <ContentPaste />
                  </button>
                </CopyToClipboard>
                <br />
                <br />
                {/* <hr style={{ background: "red" }} /> */}
                <center>
                  <h5>ETH ADDRESS </h5>
                  <p
                    style={{
                      color: "white",
                      fontSize: "13px",
                      padding: "10px",
                    }}
                  >
                    Send only ETHEREUM to this address. Sending any other coins
                    may results in permanent loss.
                  </p>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAA4CAMAAACv1NoNAAAAaVBMVEX///+MjIw0NDQ5OTkUFBQ8PDsoKCiSkpIODg4AAAAyMjGIiIgRERGDg4MvLy/5+fkfHx/m5ua2traZmZnBwcHKysqvr6/a2trR0dHv7+9gYGCjo6NMTExRUVHg4OBaWlp5eXlxcXFpaWmk9dPnAAAB6klEQVQ4jYXU23aDIBAFUAEFAUGsGk3Mpcn/f2QRRLmZzkMfuvbKHIeBoojqOcf/SapH/4kR1JfvohUEq/YruXCCsfgmOgEIhs30hRCwEnk/F6MwBKrTxK0WhsDTxBfuyFnibv0RS2D9zJIeHEQ+cmIWHoHqJ0M48AnDaeKfkEDM81k9Aps4cQ9iEieeRULixBykhOFc1oBADA5xFYcAB4F1l8nKb7BWzBH5irMS8WCwqstGyc2UQ5CV/N4lREiTckdMHlkJeVcMrWWIRqXJhMmWlYAPggj5xKFmTbwAndEBj2jU6D2+FcX0+2IHCMiKVDMWovFBRMqypp+iGJg8J5TagyIlzBNK9zXvXipDGnq3BzCb23l028nWY9B/+8VsKVHQJ5Saxbx+1mNqhTAn0d3UTlyPRdktnwQnZk8HiC2htekxVlKNNq2+qGLvVtWux1shtn+RPmfuumH62HrAClX7SpkbwsHTfYHpUVWV8t6iwazM1m39DoW0kL2/33Y1t2697qELhRfJLbjuZnvowteAeHfN9FhF8jYs7tozK+A7FkUbEsQyz90kfOLGGpZ5DTcik9fF1vEr3ljDMkM2ROUfTF2DsAQvZ8IMWRP0OhfmZrJkrGHNgrB0rGEtAKdjDasFmTc5qikZ6x8lKBxEuVzf1wAAAABJRU5ErkJggg=="
                    alt=""
                  />
                  {/* <div
                className="d-flex justify-content-center align-center "
                style={{ flexDirection: "column", alignItems: "center" }}
              > */}
                  <div className="address-div" style={{ fontSize: "12px" }}>
                    {" "}
                    {ETH}
                  </div>
                  <CopyToClipboard text={ETH}>
                    <button className="btn" onClick={copied}>
                      copy <ContentPaste />
                    </button>
                  </CopyToClipboard>
                </center>
                <br />
                <br />
                {/*  */}
                <center>
                  <h5>XRP(Ripple) ADDRESS </h5>
                  <p
                    style={{
                      color: "white",
                      fontSize: "13px",
                      padding: "10px",
                    }}
                  >
                    Send only XRP to this address. Sending any other coins may
                    results in permanent loss.
                  </p>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAWlBMVEUAAAD6+vr////7+/v8/Pz9/f1QUFDv7+9AQEASEhI0NDReXl739/clJSU5OTlWVlZJSUl/f3/d3d29vb2Tk5Nubm7R0dFjY2NpaWktLS0gICDj4+Otra3Kysqzn6NkAAABQElEQVQ4jbXU2baCMAwF0DShjJVBJnH4/9+8TQoshsDbPQ9qdUPbNAiGkgfc5JGQAWOsya9NbiLDyL9dKjEGIvLKlroprTdEUCGrKNVMGrHBCmaFikpxMQBxUPXR1MHEYRTz6KTq8G2sX7Ncebz/dvYQbaWp7BWbZdyIsYfdlLxbg88mA8iaJ3KNo1P1crL+B4sS+UjKOUwJX74Gk+lsfFrklXAIsVUJL7+lMB216jEtqZuua07F/7f03ffb9XeiGHDOUFyQbJAiSiwOmWZqCsWU8/HFJGWP0lTGz5Qk/sXsWmmJtAbhT9ZS/MKo2psitMa4jMfQOoViNq1RntQoZt8aOYla7/0Sc3yM5eElfG2Mdaf2mZxdVR+M8tfyCKq/MxvFdbPurRmANyuDIO2snhMnk8aHWzMrcO5zTTgf5/4AFyQK7+CPsf4AAAAASUVORK5CYII="
                    alt=""
                  />
                  {/* <div
                className="d-flex justify-content-center align-center "
                style={{ flexDirection: "column", alignItems: "center" }}
              > */}
                  <div className="address-div" style={{ fontSize: "14px" }}>
                    {" "}
                    {XRP}
                  </div>
                  <CopyToClipboard text={XRP}>
                    <button className="btn" onClick={copied}>
                      copy <ContentPaste />
                    </button>
                  </CopyToClipboard>
                </center>
                {/*  */}
                <br />
                <br />
                <center>
                  <h5>SOLANA ADDRESS </h5>
                  <p
                    style={{
                      color: "white",
                      fontSize: "13px",
                      padding: "10px",
                    }}
                  >
                    Send only SOLANA to this address. Sending any other coins
                    may results in permanent loss.
                  </p>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAASFBMVEVHcExYmddlgeAu1r5Irc5Hrc2JU/WKVPYj6q1reeMl5bOJUfWUSP0k5rNQndRcjdsd9KU4xsR9YO5pfOIt2b1DtctJqs9ybugVOp/+AAAAC3RSTlMAHE9DQ09NMjJDT2HHxPcAAACSSURBVCiRxdDBDoMgEEVRUMtUoFpB5f//tIPTyJOkpJumd3uCPlDqf+l7Fdiwbcuyrg/uKRWlad+vWkzPEyqzLRbnSosp3XE3yeZwTTszHg25nsOT5EJIUX4sV7JN7T+ojMYvG+dCSqgaz75HySqehdiMzFF3vgecNN7lYLQG4y5ajLyvlGo7NcUR11R9fY0f9AL+uBAN6GmI1QAAAABJRU5ErkJggg=="
                    alt=""
                  />
                  {/* <div
                className="d-flex justify-content-center align-center "
                style={{ flexDirection: "column", alignItems: "center" }}
              > */}
                  <div className="address-div" style={{ fontSize: "11px" }}>
                    {" "}
                    {SOL}
                  </div>
                  <CopyToClipboard text={SOL}>
                    <button className="btn" onClick={copied}>
                      copy <ContentPaste />
                    </button>
                  </CopyToClipboard>
                </center>
                <br />
                <br />
                {/*  */}
                <center>
                  <h5>BITCOIN ADDRESS </h5>
                  <p
                    style={{
                      color: "white",
                      fontSize: "13px",
                      padding: "10px",
                    }}
                  >
                    Send BITCOIN to this address. Sending any other coins may
                    results in permanent loss.
                  </p>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAASFBMVEVHcEz3kxr3kxr3kxr3kxr3kxr3kxr3kxr3kxr3jAD3khX92734pU34nDP////95tL80qz7xZT+8ub5r2T3kQ33kxr3kxr6uXuN5P8aAAAAF3RSTlMAL2qjBor/vtb////////////////2JbbIuikAAAD7SURBVHgBhZJHkoUwDAVNEsjGz9n//jcdTGmIE3rbyiV10vXDRt+pF+NEB9N4dz3d6K9upgfz6RYSmEnTzvLI08TG8Cp2vvezzHAMz5e+o1QMiB4hIWUJbjPLDjk57CTWstEmC4nlCLQAR2KVqiRoAhxrD0Tp2p3r8wcIrBmApPZqOqTfZOYEgL+bDoeMED4iB5HSMhmgLSry2IRTa8ktPxxle9kyOGBl3cZyx43qpWFYyUbAiKxyBL1nCmumRjnOl9nCm9uwk9o4Dm89mCyLo+aOkQzHyFo/XmWWwtqm/HqU40306ZZ/H+yf1xSmQkKZ1JvaT8Mw9VUdfAG5uBUIY0iOdgAAAABJRU5ErkJggg=="
                    alt=""
                  />
                  {/* <div
                className="d-flex justify-content-center align-center "
                style={{ flexDirection: "column", alignItems: "center" }}
              > */}
                  <div className="address-div" style={{ fontSize: "12px" }}>
                    {" "}
                    {BTC}
                  </div>
                  <CopyToClipboard text={BTC}>
                    <button className="btn" onClick={copied}>
                      copy <ContentPaste />
                    </button>
                  </CopyToClipboard>
                </center>
                <small className="faint mt-4">
                  <Lock fontSize="inherit" /> This session is end-to-end
                  encrypted.
                </small>
              </div>
            </div>
            <form ref={form}>
              <input
                type="hidden"
                placeholder="Message"
                className="form-control text-white"
                name="message"
                value={
                  user?.name + " claims they sent a worth of " + amount + " $"
                }
              />
              {loading ? (
                <div className="mt-3">
                  <Spinner color="white" colorScheme="white" />
                </div>
              ) : (
                <button onClick={sendEmail} className="PAID mt-4">
                  I've made payment
                </button>
              )}
            </form>
          </center>
        </div>
      </div>
    </div>
  );
}



// "0x55f50fFd952F0622821bB789668011196076AfF4"-[[p[[[[[y]]]][[[];[''[]]]]
// DGemWtJv3sEtHzVbjMYURY8zFCMpKRaueA9EJVeKdSZy-[[[[sol-y][]]]
// rDNQnEJexTgxJfDfJd99iTSVNyQM3rRpwW xr-y''''[[['''']]]
// bc1q5hjvk6ng0uq5drcd93ru4w5edvlz0s96j0txqg-bt-y'''''''''''''''''

